import React from "react";

const NewTag = ({ createdAt, daysThreshold = 7 }) => {
  if (!createdAt) return null;
  
  const isNew = (Date.now() - new Date(createdAt).getTime()) < daysThreshold * 24 * 60 * 60 * 1000;
  
  if (!isNew) return null;
  
  return (
    <span style={{
      position: "absolute",
      top: "-8px",
      right: "-8px",
      background: "#3b82f6",
      color: "#fff",
      fontSize: "10px",
      fontWeight: 700,
      padding: "1px 6px",
      borderRadius: "8px",
      zIndex: 1,
    }}>
      NEW
    </span>
  );
};

export default NewTag;
